export const MAIN_URL = `https://ib.mondfx.com/api`;
// export const MAIN_URL = `http://192.168.200.110:8001/api`;
export const TIMEOUT_SEC = 15;
